export default __webpack_public_path__ + "static/sprite-ad3ab03f342471a9e03a1d4c0edff900.svg";